export interface CityGeoBounds {
  name: string;
  minLat: number;
  maxLat: number;
  minLng: number;
  maxLng: number;
}

export const COLOMBIA_GLOBAL_BOUNDS = {
  minLat: -4.3,
  maxLat: 13.5,
  minLng: -79.5,
  maxLng: -66.8,
};

export const MAJOR_CITIES_BOUNDS: Record<string, CityGeoBounds> = {
  bogota: { name: 'Bogotá D.C.', minLat: 4.45, maxLat: 4.88, minLng: -74.25, maxLng: -73.95 },
  soacha: { name: 'Soacha', minLat: 4.50, maxLat: 4.65, minLng: -74.30, maxLng: -74.15 },
  chia: { name: 'Chía', minLat: 4.80, maxLat: 4.92, minLng: -74.10, maxLng: -74.00 },
  medellin: { name: 'Medellín', minLat: 6.10, maxLat: 6.45, minLng: -75.72, maxLng: -75.45 },
  envigado: { name: 'Envigado', minLat: 6.12, maxLat: 6.20, minLng: -75.62, maxLng: -75.52 },
  bello: { name: 'Bello', minLat: 6.30, maxLat: 6.38, minLng: -75.60, maxLng: -75.52 },
  itagui: { name: 'Itagüí', minLat: 6.15, maxLat: 6.20, minLng: -75.64, maxLng: -75.58 },
  sabaneta: { name: 'Sabaneta', minLat: 6.13, maxLat: 6.17, minLng: -75.63, maxLng: -75.59 },
  cali: { name: 'Cali', minLat: 3.25, maxLat: 3.58, minLng: -76.62, maxLng: -76.42 },
  jamundi: { name: 'Jamundí', minLat: 3.20, maxLat: 3.32, minLng: -76.60, maxLng: -76.48 },
  barranquilla: { name: 'Barranquilla', minLat: 10.85, maxLat: 11.10, minLng: -74.92, maxLng: -74.72 },
  soledad: { name: 'Soledad', minLat: 10.88, maxLat: 10.95, minLng: -74.82, maxLng: -74.74 },
  bucaramanga: { name: 'Bucaramanga', minLat: 7.05, maxLat: 7.20, minLng: -73.20, maxLng: -73.05 },
  floridablanca: { name: 'Floridablanca', minLat: 7.02, maxLat: 7.12, minLng: -73.15, maxLng: -73.06 },
  cartagena: { name: 'Cartagena', minLat: 10.30, maxLat: 10.55, minLng: -75.58, maxLng: -75.40 },
  santamarta: { name: 'Santa Marta', minLat: 11.10, maxLat: 11.32, minLng: -74.25, maxLng: -74.12 },
  pereira: { name: 'Pereira', minLat: 4.75, maxLat: 4.88, minLng: -75.78, maxLng: -75.63 },
  manizales: { name: 'Manizales', minLat: 5.00, maxLat: 5.12, minLng: -75.55, maxLng: -75.42 },
  armenia: { name: 'Armenia', minLat: 4.48, maxLat: 4.58, minLng: -75.75, maxLng: -75.64 },
  ibague: { name: 'Ibagué', minLat: 4.38, maxLat: 4.50, minLng: -75.28, maxLng: -75.15 },
  cucuta: { name: 'Cúcuta', minLat: 7.82, maxLat: 7.96, minLng: -72.55, maxLng: -72.45 },
  villavicencio: { name: 'Villavicencio', minLat: 4.08, maxLat: 4.20, minLng: -73.68, maxLng: -73.55 },
};

export function normalizeCityKey(city?: string | null): string {
  if (!city) return '';
  return city
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]/g, '');
}

export function validateCityCoordinates(
  cityName?: string | null,
  lat?: number | null,
  lng?: number | null
): { valid: boolean; reason?: string } {
  if (lat === null || lat === undefined || lng === null || lng === undefined) {
    return { valid: false, reason: 'Coordenadas no registradas (nulas)' };
  }
  if (lat === 0 && lng === 0) {
    return { valid: false, reason: 'Coordenadas en punto cero (0, 0)' };
  }
  if (
    lat < COLOMBIA_GLOBAL_BOUNDS.minLat ||
    lat > COLOMBIA_GLOBAL_BOUNDS.maxLat ||
    lng < COLOMBIA_GLOBAL_BOUNDS.minLng ||
    lng > COLOMBIA_GLOBAL_BOUNDS.maxLng
  ) {
    return { valid: false, reason: `Coordenadas (${lat.toFixed(3)}, ${lng.toFixed(3)}) fuera de Colombia` };
  }

  const key = normalizeCityKey(cityName);
  const bounds = MAJOR_CITIES_BOUNDS[key];
  if (bounds) {
    const inLat = lat >= bounds.minLat && lat <= bounds.maxLat;
    const inLng = lng >= bounds.minLng && lng <= bounds.maxLng;
    if (!inLat || !inLng) {
      return {
        valid: false,
        reason: `Coordenadas (${lat.toFixed(3)}, ${lng.toFixed(3)}) no corresponden a ${bounds.name}`,
      };
    }
  }

  return { valid: true };
}
